import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify } from "../../utils/utils";

const urlBaseOrdenTrabajo = process.env.REACT_APP_TMAN_API + '/WorkOrder'
const urlBaseSettings = process.env.REACT_APP_TMAN_API + '/Setting'
const urlBaseDiagnostico = process.env.REACT_APP_TMAN_API + '/Diagnosis'

export const useOrdenTrabajo = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const ordenDefault = {
        codEmpresa: codEmpresa,
        codUnidad: 0,
        codPersonaConductor: 0,
        comentarioOrdenTrabajo: '',
        codUsuarioAccion: stateUser.codUsuario,
        ultimoKilometraje: 0,
        parametroCodBim: [],
        
        codOrdenTrabajo: 0
    }

    const [orden,setOrden] = useState(ordenDefault)
    const [ordenes,setOrdenes] = useState([])
    const [ultimoDocumentoOT,setUltimoDocumentoOT] = useState('')

    const [bimsPendientesPorUnidad,setBimsPendientesPorUnidad] = useState({})

    const [estados,setEstados] = useState([])

    const [detalladoDiagnosticoTaller,setDetalladoDiagnosicoTaller] = useState({})
    
    const listarOrdenes = async (fechaInicio,fechaFin,codEstado) => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                codEstado: codEstado,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        if(response.isValid){
            setOrdenes(response.content.reverse())
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarEditarOrden = async () => {
        const esGuardar = orden.codOrdenTrabajo === 0
        const {codOrdenTrabajo,...jsonGuardar} = orden

        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo,
            method: esGuardar ? 'POST' : 'PUT',
            body: JSON.stringify(esGuardar ? jsonGuardar : orden)
        })
        
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const eliminarOrden = async (motivoAnulacion) => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo,
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codOrdenTrabajo: orden.codOrdenTrabajo,
                motivoAnulacion: motivoAnulacion,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const obtenerUltimoDocumentoOT = async () => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '/documentNumbering?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        if(response.isValid){
            setUltimoDocumentoOT(response.content[0].nroDocumento)
        }else{
            notify(response.exceptions[0].description, 'error')
        }
    }
    
    const listarBimsPendientesPorUnidad = async (codUnidad) => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '/pending?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad
            }),
        })
        if(response.isValid){
            setBimsPendientesPorUnidad(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarComboEstados = async () => {
        const response = await AuthFetch({
            url: urlBaseSettings + '/management?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setEstados(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    const editarValorOrden = (key,value) => {
        setOrden(valorAnterior => {
            return{
                ...valorAnterior,
                [key]: value
            }
        })
    }


    // DIAGNOSTICO TALLER
    const registrarDiagnosticoTaller = async ({comentarioDiagnostico,codigoOrdenTrabajo,listadoRepuestos}) => {
        const response = await AuthFetch({
            url: urlBaseDiagnostico,
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                comentarioDiagnosticoTaller: comentarioDiagnostico,
                codUsuarioAccion: stateUser.codUsuario,
                codOrdenTrabajo: codigoOrdenTrabajo,
                parametroCodActividad: "",      // EN LA WEB NO MANDA NADA
                parametroDiagnosticoTallerDetalle: listadoRepuestos
                // listadoRepuestos de la forma
                // [
                //     {
                //     "codRepuesto": 0,
                //     "cantidad": 0,
                //     "descripcionRepuesto": ""
                //     }
                // ]
            })
        })
        return {
            CodResultado : response.isValid ? 1 : 0,
            DesResultado : response.isValid ? response.content.desResultado : response.exceptions[0].description
        }
    }

    const listarDetalladoDiagnosticoTaller = async (codigoDiagnosticoTaller) => {
        const response = await AuthFetch({
            url: urlBaseDiagnostico + '/codDiagnosticoTaller?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                CodDiagnosticoTaller: codigoDiagnosticoTaller
            })
        })
        if(response.isValid){
            setDetalladoDiagnosicoTaller({...response.content.detalladoDiagnosticoTaller,afectaNeumatico: response.content.movimientoNeumatico.afectaNeumatico})
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const apruebaDiagnosticoTaller = async ({codigoDiagnostico,comentarioPlanificador,aprobar}) => {
        const response = await AuthFetch({
            url: urlBaseDiagnostico + '/approve',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codDiagnosticoTaller: codigoDiagnostico,
                codEstado: aprobar ? 37 : 38,       // 37 -> Aprobado, 38 -> Rechazado
                codUsuarioAccion: stateUser.codUsuario,
                comentarioPlanificador: comentarioPlanificador
            })
        })
        return{
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const finalizaDiagnosticoTaller = async (codigoDiagnostico) => {
        const response = await AuthFetch({
            url: urlBaseDiagnostico + '/finish',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codDiagnosticoTaller: codigoDiagnostico,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }



    // NUEVAS FUNCIONES PARA LA ACTUALIZACION DE ESTADOS
    const atenderOTNuevo = async ({
        codigoOT,
        comentario,
        fechaHoraInicio,
        fechaHoraFin,
        urlImagen,
        codPersonaMecanico
    }) => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '/served',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario,
                codOrdenTrabajo: codigoOT,
                comentario: comentario,
                fechaHoraInicio: fechaHoraInicio,
                fechaHoraFin: fechaHoraFin,
                urlImagen: urlImagen,
                codPersonaMecanico: codPersonaMecanico
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }
    const finalizarOTNuevo = async ({
        codPersonaConductor,
        fecha,
        comentario,
        codigoOT
    }) => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '/finished',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario,
                codPersonaConductor: codPersonaConductor,
                fecha: fecha,
                comentario: comentario,
                codOrdenTrabajo: codigoOT,
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    
    return {
        orden,
        setOrden,
        editarValorOrden,
        ordenDefault,
        listarOrdenes,
        ordenes,
        registrarEditarOrden,
        eliminarOrden,
        obtenerUltimoDocumentoOT,
        ultimoDocumentoOT,

        listarBimsPendientesPorUnidad,
        bimsPendientesPorUnidad,

        listarComboEstados,
        estados,

        registrarDiagnosticoTaller,

        listarDetalladoDiagnosticoTaller,
        detalladoDiagnosticoTaller,

        apruebaDiagnosticoTaller,
        finalizaDiagnosticoTaller,


        atenderOTNuevo,
        finalizarOTNuevo
    }
};
